
<script>
import { h, createVNode } from 'vue';
import { Close, FullScreen, Odometer } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus';

const iconMap = {
  Close,
  FullScreen,
  dashboard: Odometer
}

export default {
  props: ['name', 'size', 'color'],
  render() {
    const { size, color, name } = this;
    const iconComponent = iconMap[name];
    if (!iconComponent) {
      return null;
    }
    return h(
      ElIcon,
      {
        size: size || 16,
        color: color,
      },
      () => createVNode(iconComponent),
    );
  }
}
</script>

<style>

</style>
